import { css } from "@emotion/core"
import { Link } from "gatsby"
import { Cluster } from "../common"


export const StoreLogos = props => {

  return <Cluster space="var(--s1)" justify="center">

    <Link to="https://apps.apple.com/in/app/zincash/id1581920928" target="_blank" style={{ justifyContent: 'center', alignItems: 'center' }}>
      <img
        width="90"
        //  height="20"
        src="https://res.cloudinary.com/dhoiqmk4x/image/upload/v1630934856/apple_jrlute.png"
        alt="logo"
        css={css`
            @media screen and (max-width: 200px) {
              margin-bottom: 0 !important;
            }
          `}
      />
    </Link>
    <Link to="https://play.google.com/store/apps/details?id=com.zavrofinserv.customer" target="_blank"
     style={{ justifyContent: 'center', alignItems: 'center' }}>
      <img
        width="90"
        //  height="20"
        src="https://res.cloudinary.com/dhoiqmk4x/image/upload/v1630934494/android_ma9ttf.png"
        alt="logo"
        css={css`
            @media screen and (max-width: 200px) {
              margin-bottom: 0 !important;
            }
          `}
      />
    </Link>
  </Cluster>
}